import { render } from "./DeleteRenderer.vue?vue&type=template&id=2d3bbb17"
const script = {}

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__